export enum TransactionTypes {
  FINANCE_VOUCHERS = "financeVouchers",
  SUPPLIER_INVOICES = "supplierInvoices",
}

export const transactionTypesLabels = new Map<string, string>([
  [TransactionTypes.FINANCE_VOUCHERS, "TRANSACTIONS.VIEW.FINANCE_VOUCHERS_TITLE"],
  [TransactionTypes.SUPPLIER_INVOICES, "TRANSACTIONS.VIEW.SUPPLIER_INVOICES_TITLE"],
]);
